export default __webpack_public_path__ + "static/media/ProstateUltrasoundConsent-bx.6e27e1bc.pdf";